// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");

var initialState = {
  placeName: "",
  searching: false,
  candidates: /* [] */0,
  selectedPlace: undefined,
  error: undefined,
  editingReviewUrl: false,
  editedReviewUrl: "",
  confirming: false,
  selectionConfirmed: false
};

function reducer(state, action) {
  if (typeof action !== "object") {
    switch (action) {
      case "StartSearch" :
          return {
                  placeName: state.placeName,
                  searching: true,
                  candidates: /* [] */0,
                  selectedPlace: state.selectedPlace,
                  error: undefined,
                  editingReviewUrl: state.editingReviewUrl,
                  editedReviewUrl: state.editedReviewUrl,
                  confirming: state.confirming,
                  selectionConfirmed: state.selectionConfirmed
                };
      case "ClearSelection" :
          return {
                  placeName: state.placeName,
                  searching: state.searching,
                  candidates: state.candidates,
                  selectedPlace: undefined,
                  error: state.error,
                  editingReviewUrl: false,
                  editedReviewUrl: "",
                  confirming: false,
                  selectionConfirmed: false
                };
      case "StartEditingReviewUrl" :
          var place = state.selectedPlace;
          if (place !== undefined) {
            return {
                    placeName: state.placeName,
                    searching: state.searching,
                    candidates: state.candidates,
                    selectedPlace: state.selectedPlace,
                    error: state.error,
                    editingReviewUrl: true,
                    editedReviewUrl: place.reviewUrl,
                    confirming: state.confirming,
                    selectionConfirmed: state.selectionConfirmed
                  };
          } else {
            return state;
          }
      case "SaveReviewUrl" :
          var place$1 = state.selectedPlace;
          if (place$1 !== undefined) {
            return {
                    placeName: state.placeName,
                    searching: state.searching,
                    candidates: state.candidates,
                    selectedPlace: {
                      placeId: place$1.placeId,
                      name: place$1.name,
                      address: place$1.address,
                      rating: place$1.rating,
                      totalRatings: place$1.totalRatings,
                      reviewUrl: state.editedReviewUrl
                    },
                    error: state.error,
                    editingReviewUrl: false,
                    editedReviewUrl: state.editedReviewUrl,
                    confirming: state.confirming,
                    selectionConfirmed: state.selectionConfirmed
                  };
          } else {
            return state;
          }
      case "CancelEditingReviewUrl" :
          var place$2 = state.selectedPlace;
          if (place$2 !== undefined) {
            return {
                    placeName: state.placeName,
                    searching: state.searching,
                    candidates: state.candidates,
                    selectedPlace: state.selectedPlace,
                    error: state.error,
                    editingReviewUrl: false,
                    editedReviewUrl: place$2.reviewUrl,
                    confirming: state.confirming,
                    selectionConfirmed: state.selectionConfirmed
                  };
          } else {
            return {
                    placeName: state.placeName,
                    searching: state.searching,
                    candidates: state.candidates,
                    selectedPlace: state.selectedPlace,
                    error: state.error,
                    editingReviewUrl: false,
                    editedReviewUrl: "",
                    confirming: state.confirming,
                    selectionConfirmed: state.selectionConfirmed
                  };
          }
      case "StartConfirming" :
          return {
                  placeName: state.placeName,
                  searching: state.searching,
                  candidates: state.candidates,
                  selectedPlace: state.selectedPlace,
                  error: state.error,
                  editingReviewUrl: state.editingReviewUrl,
                  editedReviewUrl: state.editedReviewUrl,
                  confirming: true,
                  selectionConfirmed: false
                };
      case "FinishConfirming" :
          return {
                  placeName: state.placeName,
                  searching: state.searching,
                  candidates: state.candidates,
                  selectedPlace: state.selectedPlace,
                  error: state.error,
                  editingReviewUrl: state.editingReviewUrl,
                  editedReviewUrl: state.editedReviewUrl,
                  confirming: false,
                  selectionConfirmed: state.selectionConfirmed
                };
      case "ConfirmSelection" :
          return {
                  placeName: state.placeName,
                  searching: state.searching,
                  candidates: state.candidates,
                  selectedPlace: state.selectedPlace,
                  error: state.error,
                  editingReviewUrl: state.editingReviewUrl,
                  editedReviewUrl: state.editedReviewUrl,
                  confirming: false,
                  selectionConfirmed: true
                };
      
    }
  } else {
    switch (action.TAG) {
      case "SetPlaceName" :
          return {
                  placeName: action._0,
                  searching: state.searching,
                  candidates: state.candidates,
                  selectedPlace: state.selectedPlace,
                  error: undefined,
                  editingReviewUrl: state.editingReviewUrl,
                  editedReviewUrl: state.editedReviewUrl,
                  confirming: state.confirming,
                  selectionConfirmed: state.selectionConfirmed
                };
      case "SearchSuccess" :
          return {
                  placeName: state.placeName,
                  searching: false,
                  candidates: action._0,
                  selectedPlace: state.selectedPlace,
                  error: undefined,
                  editingReviewUrl: state.editingReviewUrl,
                  editedReviewUrl: state.editedReviewUrl,
                  confirming: state.confirming,
                  selectionConfirmed: state.selectionConfirmed
                };
      case "SearchError" :
          return {
                  placeName: state.placeName,
                  searching: false,
                  candidates: /* [] */0,
                  selectedPlace: state.selectedPlace,
                  error: action._0,
                  editingReviewUrl: state.editingReviewUrl,
                  editedReviewUrl: state.editedReviewUrl,
                  confirming: state.confirming,
                  selectionConfirmed: state.selectionConfirmed
                };
      case "SelectPlace" :
          return {
                  placeName: state.placeName,
                  searching: state.searching,
                  candidates: state.candidates,
                  selectedPlace: action._0,
                  error: state.error,
                  editingReviewUrl: false,
                  editedReviewUrl: state.editedReviewUrl,
                  confirming: state.confirming,
                  selectionConfirmed: false
                };
      case "UpdateReviewUrl" :
          return {
                  placeName: state.placeName,
                  searching: state.searching,
                  candidates: state.candidates,
                  selectedPlace: state.selectedPlace,
                  error: state.error,
                  editingReviewUrl: state.editingReviewUrl,
                  editedReviewUrl: action._0,
                  confirming: state.confirming,
                  selectionConfirmed: state.selectionConfirmed
                };
      
    }
  }
}

function decodePlaceCandidate(json) {
  return {
          placeId: Json_decode.field("place_id", Json_decode.string, json),
          name: Json_decode.field("name", Json_decode.string, json),
          address: Json_decode.field("address", Json_decode.string, json),
          rating: Json_decode.field("rating", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json),
          totalRatings: Json_decode.field("total_ratings", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          reviewUrl: Json_decode.field("review_url", Json_decode.string, json)
        };
}

function GooglePlacesSearch(props) {
  var onCancel = props.onCancel;
  var onPlaceSelect = props.onPlaceSelect;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var searchGooglePlace = function (param) {
    if (state.placeName.trim() === "") {
      return Curry._1(dispatch, {
                  TAG: "SearchError",
                  _0: "Please enter a place name"
                });
    }
    Curry._1(dispatch, "StartSearch");
    var params = {};
    params["place_name"] = state.placeName;
    Js_promise.$$catch((function (_error) {
            Curry._1(dispatch, {
                  TAG: "SearchError",
                  _0: "Network error. Please try again."
                });
            return Promise.resolve();
          }), Js_promise.then_((function (response) {
                var status = Json_decode.field("status", (function (param) {
                        return Json_decode.withDefault("failed", Json_decode.string, param);
                      }), response);
                if (status === "success") {
                  var candidates = Json_decode.field("data", (function (param) {
                          return Json_decode.field("candidates", (function (param) {
                                        return Json_decode.list(decodePlaceCandidate, param);
                                      }), param);
                        }), response);
                  if (candidates === /* [] */0) {
                    Curry._1(dispatch, {
                          TAG: "SearchError",
                          _0: "No places found. Try a different search term."
                        });
                  } else {
                    Curry._1(dispatch, {
                          TAG: "SearchSuccess",
                          _0: candidates
                        });
                  }
                } else {
                  var message = Json_decode.field("message", (function (param) {
                          return Json_decode.withDefault("Search failed", Json_decode.string, param);
                        }), response);
                  Curry._1(dispatch, {
                        TAG: "SearchError",
                        _0: message
                      });
                }
                return Promise.resolve();
              }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/redirection_urls/search_google_place", params)));
  };
  var handleKeyPress = function ($$event) {
    if ($$event.key === "Enter") {
      return searchGooglePlace();
    }
    
  };
  var error = state.error;
  var place = state.selectedPlace;
  var match$1 = state.confirming;
  var match$2 = state.selectionConfirmed;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Search for your business on Google",
                              className: "block text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("input", {
                                      className: "flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200",
                                      disabled: state.searching,
                                      placeholder: "e.g., Geckolyst Solutions Private Limited",
                                      type: "text",
                                      value: state.placeName,
                                      onKeyPress: handleKeyPress,
                                      onChange: (function (e) {
                                          var value = e.target.value;
                                          Curry._1(dispatch, {
                                                TAG: "SetPlaceName",
                                                _0: value
                                              });
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: state.searching ? "Searching..." : "Search",
                                      className: "px-6 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 " + (
                                        state.searching || state.placeName.trim() === "" ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
                                      ),
                                      disabled: state.searching || state.placeName.trim() === "",
                                      onClick: (function (param) {
                                          searchGooglePlace();
                                        })
                                    })
                              ],
                              className: "flex gap-2"
                            }),
                        error !== undefined ? JsxRuntime.jsxs("p", {
                                children: [
                                  JsxRuntime.jsx("span", {
                                        children: "⚠",
                                        className: "mr-1"
                                      }),
                                  error
                                ],
                                className: "mt-2 text-sm text-red-600 flex items-center"
                              }) : null
                      ]
                    }),
                state.candidates !== /* [] */0 ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("p", {
                                children: "Select your business:",
                                className: "text-sm font-medium text-gray-700"
                              }),
                          JsxRuntime.jsx("div", {
                                children: Belt_Array.map(Belt_List.toArray(state.candidates), (function (candidate) {
                                        var place = state.selectedPlace;
                                        var isSelected = place !== undefined ? place.placeId === candidate.placeId : false;
                                        var match = candidate.rating;
                                        var match$1 = candidate.totalRatings;
                                        return JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx("h4", {
                                                                          children: candidate.name,
                                                                          className: "font-semibold text-gray-900 mb-1"
                                                                        }),
                                                                    JsxRuntime.jsx("p", {
                                                                          children: candidate.address,
                                                                          className: "text-sm text-gray-600 mb-2"
                                                                        }),
                                                                    match !== undefined && match$1 !== undefined ? JsxRuntime.jsxs("div", {
                                                                            children: [
                                                                              JsxRuntime.jsx("span", {
                                                                                    children: "★",
                                                                                    className: "text-yellow-500 mr-1"
                                                                                  }),
                                                                              JsxRuntime.jsx("span", {
                                                                                    children: String(match) + " (" + String(match$1) + " reviews)"
                                                                                  })
                                                                            ],
                                                                            className: "flex items-center text-sm text-gray-500"
                                                                          }) : null
                                                                  ],
                                                                  className: "flex-1"
                                                                }),
                                                            isSelected ? JsxRuntime.jsx("span", {
                                                                    children: "✓",
                                                                    className: "ml-2 text-blue-600 text-xl"
                                                                  }) : null
                                                          ],
                                                          className: "flex items-start justify-between"
                                                        }),
                                                    className: "p-4 border rounded-lg cursor-pointer transition-all duration-200 " + (
                                                      isSelected ? "border-blue-500 bg-blue-50 shadow-md" : "border-gray-200 hover:border-blue-300 hover:shadow-sm"
                                                    ),
                                                    onClick: (function (param) {
                                                        Curry._1(dispatch, {
                                                              TAG: "SelectPlace",
                                                              _0: candidate
                                                            });
                                                      })
                                                  }, candidate.placeId);
                                      })),
                                className: "space-y-2 max-h-96 overflow-y-auto"
                              })
                        ],
                        className: "space-y-2"
                      }) : null,
                place !== undefined ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("span", {
                                                children: "✓",
                                                className: "text-green-600 text-xl mr-2"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("p", {
                                                        children: "Selected Business",
                                                        className: "text-sm font-medium text-green-900 mb-1"
                                                      }),
                                                  JsxRuntime.jsx("p", {
                                                        children: place.name,
                                                        className: "text-sm text-green-800"
                                                      })
                                                ]
                                              })
                                        ],
                                        className: "flex items-start"
                                      }),
                                  state.editingReviewUrl ? null : JsxRuntime.jsx("button", {
                                          children: "Edit URL",
                                          className: "text-xs text-green-700 hover:text-green-900 underline whitespace-nowrap",
                                          onClick: (function (param) {
                                              Curry._1(dispatch, "StartEditingReviewUrl");
                                            })
                                        })
                                ],
                                className: "flex items-start justify-between mb-2"
                              }),
                          state.editingReviewUrl ? JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("label", {
                                          children: "Review URL",
                                          className: "block text-xs font-medium text-green-900"
                                        }),
                                    JsxRuntime.jsx("input", {
                                          className: "w-full px-3 py-2 text-xs font-mono border border-green-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white",
                                          placeholder: "https://search.google.com/local/writereview?placeid=...",
                                          type: "text",
                                          value: state.editedReviewUrl,
                                          onChange: (function (e) {
                                              var value = e.target.value;
                                              Curry._1(dispatch, {
                                                    TAG: "UpdateReviewUrl",
                                                    _0: value
                                                  });
                                            })
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("button", {
                                                  children: "Cancel",
                                                  className: "px-3 py-1 text-xs font-medium text-green-700 bg-white border border-green-300 rounded hover:bg-green-50 transition-colors duration-200",
                                                  onClick: (function (param) {
                                                      Curry._1(dispatch, "CancelEditingReviewUrl");
                                                    })
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: "Save",
                                                  className: "px-3 py-1 text-xs font-medium text-white rounded transition-colors duration-200 " + (
                                                    state.editedReviewUrl.trim() === "" ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"
                                                  ),
                                                  disabled: state.editedReviewUrl.trim() === "",
                                                  onClick: (function (param) {
                                                      Curry._1(dispatch, "SaveReviewUrl");
                                                    })
                                                })
                                          ],
                                          className: "flex justify-end space-x-2"
                                        })
                                  ],
                                  className: "mt-3 space-y-2"
                                }) : JsxRuntime.jsx("p", {
                                  children: "Review URL: " + place.reviewUrl,
                                  className: "text-xs text-green-600 mt-2 font-mono break-all"
                                })
                        ],
                        className: "p-4 bg-green-50 border border-green-200 rounded-lg"
                      }) : null,
                match$1 ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("svg", {
                                      children: [
                                        JsxRuntime.jsx("circle", {
                                              className: "opacity-25",
                                              cx: "12",
                                              cy: "12",
                                              r: "10",
                                              stroke: "currentColor",
                                              strokeWidth: "4"
                                            }),
                                        JsxRuntime.jsx("path", {
                                              className: "opacity-75",
                                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
                                              fill: "currentColor"
                                            })
                                      ],
                                      className: "animate-spin h-6 w-6 text-green-600",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }),
                                JsxRuntime.jsx("span", {
                                      children: "Confirming selection...",
                                      className: "text-sm font-medium text-green-700"
                                    })
                              ],
                              className: "flex items-center space-x-3"
                            }),
                        className: "flex justify-center items-center py-6 border-t border-gray-200"
                      }) : (
                    match$2 ? JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: "✓",
                                            className: "inline-flex h-8 w-8 items-center justify-center rounded-full bg-green-100 text-green-600"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("p", {
                                                    children: "Business selected successfully",
                                                    className: "text-sm font-medium text-green-800"
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "You can proceed to save the URL or change the selection.",
                                                    className: "text-xs text-green-600"
                                                  })
                                            ]
                                          })
                                    ],
                                    className: "flex items-center space-x-3"
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: "Change selection",
                                    className: "px-4 py-2 text-xs font-semibold text-green-700 border border-green-200 rounded-lg hover:bg-green-50 transition-colors duration-200",
                                    onClick: (function (param) {
                                        Curry._1(dispatch, "ClearSelection");
                                      })
                                  })
                            ],
                            className: "flex justify-between items-center py-4 border-t border-gray-200"
                          }) : JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Cancel",
                                    className: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                    onClick: (function (param) {
                                        Curry._1(onCancel, undefined);
                                      })
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: "Use This Place",
                                    className: "px-6 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 " + (
                                      state.selectedPlace === undefined ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"
                                    ),
                                    disabled: state.selectedPlace === undefined,
                                    onClick: (function (param) {
                                        var place = state.selectedPlace;
                                        if (place !== undefined) {
                                          Curry._1(dispatch, "StartConfirming");
                                          setTimeout((function (param) {
                                                  Curry._1(onPlaceSelect, place);
                                                  Curry._1(dispatch, "ConfirmSelection");
                                                }), 600);
                                          return ;
                                        }
                                        
                                      })
                                  })
                            ],
                            className: "flex justify-end space-x-3 pt-4 border-t border-gray-200"
                          })
                  )
              ],
              className: "space-y-4"
            });
}

var make = GooglePlacesSearch;

exports.initialState = initialState;
exports.reducer = reducer;
exports.decodePlaceCandidate = decodePlaceCandidate;
exports.make = make;
/* react Not a pure module */
